import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

export const Container = styled.section`
  padding: 15px 15px 0 15px;
`;

export const Header: any = styled.div``;

Header.Type = styled.span`
  font-size: 14px;
  color: ${ColorPalette.HEX.DimGray2};
`;

Header.Date = styled.h2`
  color: ${ColorPalette.HEX.PineTree};
  font-weight: 600;
  font-size: 24px;
  line-height: 25px;
`;

Header.Destiny = styled.span`
  font-size: 14px;
  color: ${ColorPalette.HEX.DimGray2};
`;

export const SectorContainer = styled.section`
  margin-top: 20px;
`;

export const SectorDivider = styled.div`
  height: 1px;
  background: ${ColorPalette.HEX.BrightGray5};
  margin-top: 20px;
`;
